module.exports = __webpack_public_path__ + "img/motoacqua.110bec9d.svg";